import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface LoadingProps {
  isCover?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ isCover = false }) => (
  <div
    className={cx('loading', { cover: isCover })}
    aria-label="Loading..."
    aria-busy="true"
  />
);

export default Loading;
